import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingImagesService {
 token=''
  constructor(private http: HttpClient, public baseURL: BasemodelService) { }




  getstate(){
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(this.baseURL.getCommonUrl() +'/apiV2/common/employeeStates',{headers})
  }
   getcity(stateId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get( this.baseURL.getCommonUrl() +"/apiV2/common/emplStateCities?stateId=" + stateId, { headers })

  }
  getBuildingListFilter(payload: any) {

  const headers = new HttpHeaders({
    'Authorization': this.token,
    'Content-Type': 'application/json'
  });

  return this.http.post(this.baseURL.getCommonUrl() +'/employee/api/jwtV2/buildingMaster/buildingFilter', payload, { headers }
  );
}
getbuildimagelist(buildingId:any){
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get( this.baseURL.getCommonUrl() +"/employee/api/jwtV2/capGeoloc/getBuildingImage?buildingId="+ buildingId, { headers })

  }
}

